import { createOrUpdateTenderApplicationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createOrUpdateTenderApplicationCallable = getCallable(
  createOrUpdateTenderApplicationDefinition,
);
